import index from './spinner'

export default index